// extracted by mini-css-extract-plugin
export default {"card":"Card_card__z2HXS","number":"Card_number__295Ss","text":"Card_text__86DUS"};